import {
  Component,
  Input,
  ContentChild,
  TemplateRef,
  ChangeDetectionStrategy,
} from '@angular/core'
import { trigger, state, style, animate, transition } from '@angular/animations'
import { CommonModule } from '@angular/common'
import { IconComponent } from '../icon'
import { TypographyComponent } from '../typography'
import { TagComponent } from '../tag'

@Component({
  standalone: true,
  selector: 'hyperkit-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
  animations: [
    trigger('expandCollapse', [
      state(
        'collapsed',
        style({
          height: '0',
          overflow: 'hidden',
          opacity: 0,
        }),
      ),
      state(
        'expanded',
        style({
          height: '*',
          opacity: 1,
        }),
      ),
      transition('collapsed <=> expanded', [animate('200ms ease-in-out')]),
    ]),
  ],
  imports: [
    CommonModule,
    IconComponent,
    TypographyComponent,
    TagComponent,
    IconComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccordionComponent {
  @Input() title = ''
  @Input() expanded = false
  @Input() badgeText = ''
  @ContentChild('headerTemplate') headerTemplate: TemplateRef<any> | null = null

  toggleExpanded(): void {
    this.expanded = !this.expanded
  }
}
